var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShow())?_c('div',{staticClass:"cert-row"},_vm._l((_vm.attachments),function(attachment){return _c('ul',{key:attachment.id},[_c('li',[_c('a',{attrs:{"href":_vm.attachmentURL(attachment),"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.attachmentName(attachment))+"\n      ")])])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }